<div class="rx-intuitive-tooth-editor-body">
	<tlk-card
		*ngIf="shouldShowImplantsSummary; else standardBody"
		(click)="onImplantBasedSummaryClick()"
		[padding]="16"
		class="rx-intuitive-tooth-editor-body__implant-based"
	>
		<div class="rx-intuitive-tooth-editor-body__implant-based-summary">
		<span *ngIf="showImplantsSummaryLine" class="rx-intuitive-tooth-editor-body__implant-based-summary-line tlk-typo-label_size_m">
				{{ implantsTreatmentSummary }}
			</span>
			<span
				*ngIf="hasTreatmentPreviewLine"
				class="rx-intuitive-tooth-editor-body__implant-based-summary-line tlk-typo-label_size_m"
			>
				{{ treatmentPreviewLine }}
			</span>
			<span *ngIf="isInvalid" class="rx-intuitive-tooth-editor-body__implant-based-required-info">
				{{ 'Validation.RequiredInformationMissing' | translate }}
			</span>
		</div>
		<div class="rx-intuitive-tooth-editor-body__implant-based-icon-container">
			<tlk-chevron-right-icon class="rx-intuitive-tooth-editor-body__implant-based-icon" />
		</div>
	</tlk-card>
	<ng-template #standardBody>
		<rx-intuitive-crown
			[crownForm]="crownForm"
			[indicationId]="indicationId"
			[customLabMaterialGroup]="customLabMaterialGroup"
			[isReadOnly]="isReadOnly"
			[isBridge]="isBridge"
			(crownFormChanged)="onCrownChange($event)"
			(selectionContext)="onCrownSelectionContext($event)"
		></rx-intuitive-crown>
		<rx-pontic-selector
			*ngIf="shouldShowPonticSelector"
			class="rx-intuitive-tooth-editor-body__pontic"
			[formControl]="ponticDesignControl"
			[isReadonly]="isReadOnly"
			[options]="ponticDesigns"
			[showLabel]="false"
			name="ponticDesignControl"
		></rx-pontic-selector>
		<button
			tlkButton
			variant="ghost"
			size="m"
			class="rx-intuitive-tooth-editor-body__additional-info-btn"
			type="button"
			[disabled]="isReadOnly"
			(click)="onAdditionalInfoClick()"
		>
			{{
				((hasAdditionalInfoButtonSaved$ | async) ? 'ToothEditor.AdditionalInfoButtonSaved' : 'ToothEditor.AdditionalInfoButton') | translate
			}}
		</button>
	</ng-template>
</div>
